export default function (cli) {
  return {
    list (year, month) {
      let data = {
        year,
        month,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/sales-budgets/`).query(data)
    },
    detail (date) {
      return cli.get(`${cli.crmApiEndpoint}reports/sales-budgets/${date}/`)
    },
    bulkInsert (data) {
      return cli.post(`${cli.crmApiEndpoint}reports/sales-budgets/`).send({data: data})
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/salesBudgets.js